import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PenLine, Settings2, History } from "lucide-react";
import ComposeAnnouncement from "@/components/email/ComposeAnnouncement";
import AutomationsPanel from "@/components/email/AutomationsPanel";
import SentLog from "@/components/email/SentLog";

export default function AdminEmail() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "compose";
  const [logKey, setLogKey] = useState(0);

  return (
    <div className="space-y-6" data-testid="admin-email">
      <div>
        <h1 className="font-serif text-2xl font-semibold text-foreground sm:text-3xl">Email</h1>
        <p className="mt-1 text-muted-foreground">Write to members, decide which automatic emails go out, and see everything that was sent.</p>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList data-testid="email-tabs">
          <TabsTrigger value="compose" data-testid="email-tab-compose"><PenLine className="mr-2 h-4 w-4" />Compose</TabsTrigger>
          <TabsTrigger value="automations" data-testid="email-tab-automations"><Settings2 className="mr-2 h-4 w-4" />Automations</TabsTrigger>
          <TabsTrigger value="sent" data-testid="email-tab-sent"><History className="mr-2 h-4 w-4" />Sent</TabsTrigger>
        </TabsList>
        <TabsContent value="compose" className="pt-4"><ComposeAnnouncement onSent={() => { setLogKey((k) => k + 1); setParams({ tab: "sent" }); }} /></TabsContent>
        <TabsContent value="automations" className="pt-4"><AutomationsPanel /></TabsContent>
        <TabsContent value="sent" className="pt-4"><SentLog refreshKey={logKey} /></TabsContent>
      </Tabs>
    </div>
  );
}
